module.exports = __webpack_public_path__ + "img/47.36dad4ae.jpg";